/* eslint no-template-curly-in-string: 0 */
import walmartIcon from '../../assets/images/walmart-logo.png';
import { PAYMENT_NETWORKS } from "../../utils/enums";

export const walmart = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_WALMART,
  displayName: "Walmart™",
  paywall: {
    tile: {
      displayName: "Walmart™",
      tagline: ["Use online or in-store"],
      description: "Use online or in-store",
      logo: walmartIcon
    },
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
  },
};

export default walmart;
